import axios from "axios";

// Si estás con CRA, esto conviene más que import.meta.env
const RAW_BASE_URL =
  process.env.REACT_APP_API || "https://backsanpancracio.us-3.evennode.com";

const BASE_URL = RAW_BASE_URL.replace(/\/+$/, "");
const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- CUENTA GASTOS ----

export const getCuentaGastos = async () => {
  const { data } = await API.get(p("cuentagastos"), auth());
  return data;
};

export const getCuentaGastoById = async (id) => {
  const { data } = await API.get(p(`cuentagastos/${id}`), auth());
  return data;
};

export const postCuentaGasto = async (payload) => {
  const { data } = await API.post(p("cuentagastos"), payload, auth());
  return data;
};

export const putCuentaGasto = async (id, payload) => {
  const { data } = await API.put(p(`cuentagastos/${id}`), payload, auth());
  return data;
};

export const deleteCuentaGasto = async (id) => {
  const { data } = await API.delete(p(`cuentagastos/${id}`), auth());
  return data;
};